// This file is auto-generated by ./bin/rails update_javascript_i18n
// Run that command whenever you add to the validation error strings
// and need them on the FE.
// This file includes default messages for validations that act as fallbacks
// for form field validations when no custom messages are provided in the
// stimulus data attributes.

import { getAppConfiguration } from "lib/app_configuration";

const i18n: { [key: string]: { [key: string]: string } } = {
  en: {
    invalid: "is invalid",
    blank: "can't be blank",
    does_not_match: "doesn't match",
    generic_server_error: "Sorry, an error occurred.",
    form_invalid_preamble: "Please review the following:",
  },
};

export function localeMessage(key: string) {
  const locale = getAppConfiguration("locale");
  if (!i18n[locale]) throw new Error("Local is not supported yet");
  return i18n[locale][key] || i18n["en"][key] || key;
}
